import type { QueryClient } from '@tanstack/react-query';
import { researchConfigurationsLiteQueryKey } from '../../../hooks/queries/keys';
import { configurationFetchOptions } from '../../research/packages/spectral-workspace/queries/prefetchSessionConfigurations';
import { invalidateWorkspaceSessionQueries } from '../../research/packages/spectral-workspace/queries/invalidateWorkspaceSessionQueries';
import { sessionLiteQueryOptions } from '../queries/sessionLiteQueryOptions';
import { invalidateSessionGroupQueries } from '../queries/invalidateSessionGroupQueries';

const refreshSessionLiteMetadata = async (
  queryClient: QueryClient,
  userId: string,
  sessionId: number
) => {
  const liteKey = researchConfigurationsLiteQueryKey(userId, {
    status: 'completed',
    searchId: String(sessionId),
    page: 1,
    size: 1,
  });

  await queryClient.invalidateQueries({ queryKey: liteKey });
  await queryClient.fetchQuery({
    ...sessionLiteQueryOptions(userId, sessionId),
    staleTime: 0,
  });
};

const refreshSessionConfiguration = async (
  queryClient: QueryClient,
  sessionId: number
) => {
  await queryClient.fetchQuery({
    ...configurationFetchOptions(sessionId),
    staleTime: 0,
  });
};

export const invalidateSessionRepairCaches = async (
  queryClient: QueryClient,
  {
    userId,
    sessionIds,
    groupId,
  }: {
    userId?: string;
    sessionIds: number[];
    groupId?: string | null;
  }
) => {
  invalidateWorkspaceSessionQueries(queryClient, sessionIds);
  invalidateSessionGroupQueries(queryClient, groupId);

  await Promise.all(
    sessionIds.map(async sessionId => {
      if (userId) {
        await refreshSessionLiteMetadata(queryClient, userId, sessionId);
      }
      await refreshSessionConfiguration(queryClient, sessionId);
    })
  );
};
